import createInstancePlugin from '@elliemae/ds-shared/createDataInstance/createInstancePlugin';
import addCustomRendererToCell from './addCustomRendererToCell.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-utilities/utils';
import '@elliemae/ds-shared/useDataGrid/initColumnDefinition';
import './getRendererComponent.js';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react';
import '@elliemae/ds-basic/Button';
import '@elliemae/ds-basic/form/Checkbox';
import '@elliemae/ds-basic/form/ComboBox';
import '@elliemae/ds-basic/form/Radio';
import '@elliemae/ds-basic/form/TextBox';
import '@elliemae/ds-basic/form/Toggle';
import '@elliemae/ds-dropdownmenu';
import '../../index-4a6329dc.js';
import '../../components/renderers/defaultClassedRenderers.js';
import '@elliemae/ds-classnames';
import '../../blockNames.js';
import '../../components/renderers/renderRowsLoader.js';
import '../../components/RowsLoader.js';
import '@elliemae/ds-basic/Spinner';

var decorateColumn = function decorateColumn(column, grid) {
  return addCustomRendererToCell(grid)(column);
};

var CustomRendererPlugin = createInstancePlugin('custom-renderer', {
  decorateColumn: decorateColumn
});

export { CustomRendererPlugin };
//# sourceMappingURL=CustomRendererPlugin.js.map
